var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";
import { attachmentCompleted } from "../../Metadata/actions/supportingFilesActions";
import { uploadAttachment, uploadAttachmentFromUrl } from "../actions/actions";
import { AttachmentsModal } from "./AttachmentsModal";











function mapStateToProps({ attachments }) {
  return {
    progress: attachments.progress
  };
}

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ attachmentCompleted }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);

const UploadSupportingFile = (props) => {
  const { entitySharedId, storeKey, progress, model = '' } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => {
    setModalOpen(false);
    props.attachmentCompleted(entitySharedId);
  };

  const getPercentage = progress.get(entitySharedId);

  useEffect(() => {
    if (getPercentage === 100) {
      closeModal();
    }
  }, [progress]);

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", { type: "button", onClick: openModal, className: "btn attachments-modal-trigger" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), "\xA0", /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add file")
    ), /*#__PURE__*/

    _jsx(AttachmentsModal, {
      isOpen: modalOpen,
      onClose: closeModal,
      entitySharedId: entitySharedId,
      storeKey: storeKey,
      getPercentage: getPercentage,
      model: model,
      uploadAttachment: props.uploadAttachment || uploadAttachment,
      uploadAttachmentFromUrl: props.uploadAttachmentFromUrl || uploadAttachmentFromUrl }
    )
    ));

};

export { mapDispatchToProps, mapStateToProps };
export default connector(UploadSupportingFile);